<template>
  <div id="app">
    <!-- <navbar></navbar> -->
    <router-view/>
    <Footer></Footer>
    <!-- <footer></footer> -->
  </div>
</template>

<script>
import './assets/libraries/bootstrap/js/jquery-3.1.1.min.js'
import './assets/libraries/bootstrap/js/bootstrap.min.js'
import './assets/js/main1.js'
// import navbar from './components/navbar';
import Footer from './components/Footer';
export default {
  name: 'App',
  components: {
    // navbar,
    Footer,
  },
}
</script>

<script>
export default {
  mounted() {
    this.addGoogleAnalyticsScript();
  },
  methods: {
    addGoogleAnalyticsScript() {
      const script = document.createElement('script');
      script.src = 'https://www.googletagmanager.com/gtag/js?id=G-D4B62PL7KY';
      script.async = true;
      document.head.appendChild(script);

      script.onload = () => {
        window.dataLayer = window.dataLayer || [];
        function gtag() {
          window.dataLayer.push(arguments);
        }
        gtag('js', new Date());
        gtag('config', 'G-D4B62PL7KY');
      };
    }
  }
};
</script>

<style>
@import './assets/libraries/bootstrap/css/bootstrap.min.css';
@import './assets/css/main.css';
@import './assets/css/index.css';
@import url("https://fonts.googleapis.com/css?family=Roboto&display=swap");
</style>

<style scoped>
</style>



// WEBPACK FOOTER //
// src/App.vue